import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  CircularProgress,
  Divider,
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  Autocomplete,
} from "@material-ui/core";
import {
  AddRefrenceDataList,
  getRefrenceDataList,
  PutRefrenceDataList,
  deleteItem,
  getEmployee,
  getInvoiceType,
  getRefrenceDataListForOneRecord,
} from "../adminaction";
import CustomSnackbar from "../../../../CustomSnackbar";
import { makeStyles } from "@material-ui/styles";
import { Backdrop } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { dashboardStyle } from "../../Components/InvoiceDetails/style";
import { ArrowBack, Delete, Error } from "@mui/icons-material";


const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = makeStyles(dashboardStyle);

export default function TreasuryModel({
  setOpenModel,
  getdata,
  updateId,
  setUpdateId,
  togglebutton,
  settogglebutton,
  deleteId,
  setDeleteID,
  setSuccessMessage,
  setErrorMessage,
  getdataFromID,
  setGetDataFromID,
  setGetData,

}) {
  const [open, setOpen] = useState(false);
  // const [locationOption, setLocationOption] = React.useState([]);
  const [checked, setChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [employeelist, setEmployeeList] = useState([])
  const [invoicetypelist, setInvoiceTypeList] = useState([])
  const [referenceTextlist, setReferenceTextlist] = useState([])
  const [employeeRecorde, setEmployeeRecorde] = useState("")
  useEffect(() => {
    getEmployee("", setEmployeeList);
    getInvoiceType("InvoiceType", setInvoiceTypeList)
  }, []);
  
  const classes = useStyles();

  const [formState, setFormState] = useState({
    referenceId: 0,
    referenceKey: "Treasury",
    referenceCode: "",
    referenceText: "",
    referenceProp1: "",
    referenceProp2: "false",
    referenceProp3: "",
    referenceProp4: "",
    isActive: true,
  });

  
  const submitHandler = (e, w) => {
    e.preventDefault();
    
    if (updateId) {
      PutRefrenceDataList(formState, setFormState, setSuccessMessage, setErrorMessage, setLoader,
        setGetData,
        handleClose,

      );

    } else {

      AddRefrenceDataList(
        formState,
        setFormState,
        setLoader,
        setSuccessMessage,
        setErrorMessage,
        setGetData,

        handleClose

      );
      // getRefrenceDataList("InvoiceType",setGetData,()=>{},()=>{},()=>{},()=>{},()=>{},()=>{});
    }
  };

  useEffect(() => {

    
  }, [loader]);
  

  const enableDisable = () => {
    PutRefrenceDataList(
      formState,
      setFormState,
      setSuccessMessage,
      setErrorMessage,
      setLoader,
      setGetData,

      handleClose


    );

  };
  const Delete = () => {
    deleteItem(
      formState,
      setFormState,
  deleteId,

      setLoader,
      setSuccessMessage,
      setErrorMessage,
      setGetData,

      handleClose

    );
  };


  const clearState = (setFormState, setUpdateId, setDeleteID, settogglebutton, setGetDataFromID) => {
   

    setUpdateId("");
    setDeleteID("");
    settogglebutton("")
    setGetDataFromID("")
    setChecked("")
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
 
  };


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenModel(false);

    clearState(setFormState, setUpdateId, setDeleteID, settogglebutton, setGetDataFromID);

    // setErrAlertMessage("")
  };
  
  
  const [enable, setEnable] = useState(false)
  useEffect(() => {
    handleClickOpen();
    if (updateId || deleteId) {
      getRefrenceDataListForOneRecord(
        "Treasury",
        () => { },
        () => { },
        () => { },
        updateId,
        togglebutton,
        getdataFromID,
        setFormState,
        setChecked,
        setEmployeeRecorde,
        setReferenceTextlist
      );
    } else if (togglebutton) {
      
      const toggle = getdata.filter(
        (value) => togglebutton === value.referenceId
      );
      

      setFormState((formState) => ({
        ...formState,
        referenceId: toggle[0]?.referenceId,
        referenceKey: toggle[0]?.referenceKey,
        referenceCode: toggle[0]?.referenceCode||"",
        referenceText: toggle[0]?.referenceText||"",
        referenceProp1: toggle[0]?.referenceProp1||"",
        referenceProp2: toggle[0]?.referenceProp2||"",
        referenceProp3: toggle[0]?.referenceProp3 ||"",
        referenceProp4: toggle[0]?.referenceProp4 || "",
        isActive: toggle[0]?.isActive ? false : true,
      }));
      setEnable(toggle[0]?.isActive)
      // getRefrenceDataListForOneRecord(
      //   "Treasury",
      //   () => { },
      //   () => { },
      //   () => { },
      //   updateId,
      //   togglebutton,
      //   getdataFromID,
      //   setFormState,
      //   setChecked,

      //   ()=>{},
      //   ()=>{},

       
      // );
    }
    // get_Location();
  }, []);

  
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        // sx={{ width: "60%" }}
        fullWidth={true}
      >
        {deleteId ? (
          <>
            <DialogContent>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <HelpOutline color="secondary" fontSize="large" mt={2} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                p={2}
                mt={1}
              >
                <Typography variant="h4" style={{ width: "80%" }}>
                  Are you sure you want to Delete a User?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                m={1}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                >
                  NO
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: "20px" }}
                  onClick={Delete}
                >
                  Yes
                </Button>
              </Box>
            </DialogContent>
          </>
        ) : (
          <>
            {togglebutton ? (
              <>
                <DialogContent>
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <HelpOutline color="secondary" fontSize="large" mt={2} />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    p={2}
                    mt={1}
                  >
                    <Typography variant="h4" style={{ width: "80%" }}>
                    {enable ?"Are you sure you want to Disable this Item?" : "Are you sure you want to Enable this Item?" } 
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    m={1}
                  >
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleClose}
                    >
                      NO
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{ marginLeft: "20px" }}
                      onClick={enableDisable}
                    >
                      Yes
                    </Button>
                  </Box>
                </DialogContent>
              </>
            ) : (
              <>
                <form onSubmit={(e) => submitHandler(e)}>
                  <DialogTitle
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    Treasury
                  </DialogTitle>
                  <Divider />
                  <DialogContent>
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={loader}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                    <Grid container spacing={2} pb={3}>
                     

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Autocomplete
                          options={employeelist}
                          classes={{ option: classes.option }}
                          size="small"
                          value={employeeRecorde}
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.employeeCode}` + `-` + `${option?.employeeName}` + `-` + `${option?.position
                            }`) || ""
                          }
                          // loading={vendorLoading}
                          
                          onChange={(event, value) =>{
                            setEmployeeRecorde({
                              employeeCode:value.employeeCode,
                              employeeName:value.employeeName,
                              position:value.position
                            })
                            
                            setFormState((formState)=>({
                              ...formState,
                              referenceCode:value.employeeCode,
                              referenceText:value.employeeName,
                              referenceProp1:value.emailAddress,

                            }))
                          }
                          }
                          renderInput={(params) => (
                            <TextField
                              // sx={{ input: { color: "#888888" } }}
                              {...params}
                              name=""
                              value={""}
                              onChange={(event) => {
                                getEmployee(event.target.value, setEmployeeList);
                              }}
                              required
                              onBlur={() => getEmployee("", setEmployeeList)}
                              label="Select an Employee"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />

                      </Grid>
                     

                      <Grid item xs={12} sm={12} md={12} lg={12}>
                      <FormControlLabel
                          style={{ color: "black" }}
                          label="In CC"
                          color="secondary"
                          control={
                            <Checkbox
                              color="secondary"
                              fontSize="small"
                              checked={checked}
                              name="referenceProp2"
                              onChange={(event) => {
                                setFormState((formState) => ({
                                  ...formState,
                                  referenceProp2:
                                    event.target.checked.toString(),
                                }));
                                setChecked(event.target.checked);
                              }}
                            />
                          }
                        />

                      </Grid>

                    </Grid>
                  </DialogContent>
                  <Divider />

                  <DialogActions>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    {updateId ? (
                      <Button
                        color="success"
                        variant="contained"
                        type="submit"
                      // onClick={()=>}
                      >
                        Updated
                      </Button>
                    ) : (
                      <Button
                        color="success"
                        variant="contained"
                        type="submit"
                      //   onClick={add_role_data}
                      >
                        Save
                      </Button>
                    )}
                  </DialogActions>
                </form>
              </>
            )}
          </>
        )}
      </Dialog>
    </>
  );
}